<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->

    <div class="ui form" [formGroup]="companyEquipmentForm">
      <div class="field" [ngClass]="displayFieldCss('equipName')">
        <label>Equipment Name</label>
        <input
          formControlName="equipName"
          type="text"
          placeholder="Equipment Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('equipName')"
          errorMsg="Please company name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('equipModelNumber')">
        <label>Equipment Model Number</label>
        <input
          formControlName="equipModelNumber"
          type="text"
          placeholder="Equipment Model Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('equipModelNumber')"
          errorMsg="Please enter email address"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('equipTypeId')">
        <label>Equipment Type</label>
        <select class="ui search dropdown">
          <option value="">Equipment Type</option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('equipTypeId')"
          errorMsg="Please select department"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('yearOfManufacture')">
        <label>Year of Manufacture</label>
        <input
          formControlName="yearOfManufacture"
          type="text"
          placeholder="Year of Manufacture"
        />
        <app-field-error-display
          [displayError]="isFieldValid('yearOfManufacture')"
          errorMsg="Please select department"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
